import { FunctionComponent, ReactNode } from 'react';

type IAuth = {
  children: ReactNode;
};

export const AuthLayout: FunctionComponent<IAuth> = ({ children }: IAuth) => {
  return <>{children}</>;
};
